// What this scanner session may do beyond the tools list. The kiosk's requests carry
// the operator token (KIOSK_OPERATOR_CAPS); a browser's carry the person's own flags.

import useUserStore from '../stores/useUserStore';
import { userCanAccess } from '../navigation/menuConfig';
import { inShell } from './shell';
import { capabilitiesFor } from './capabilities';

export const useScannerCaps = (): unknown =>
  capabilitiesFor({ kiosk: inShell(), user: useUserStore((s: any) => s.user) });

/** Repair, flags, maintenance, scrap pulls, moves and Thrown out: operations or manufacturing. */
export const canWorkStock = (caps: unknown): boolean =>
  userCanAccess({ require: 'operations' }, caps) || userCanAccess({ require: 'manufacturing' }, caps);

/** Picking boxes into Assembly: manufacturing, as the pick route requires. */
export const canPickStock = (caps: unknown): boolean => userCanAccess({ require: 'manufacturing' }, caps);
